var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      ref: "select",
      staticClass: "full-width",
      attrs: {
        placeholder: _vm.placeholder,
        multiple: _vm.multiple,
        "collapse-tags": _vm.collapseTags,
        disabled: _vm.disabled,
        filterable: "",
        clearable: _vm.clearable,
        size: _vm.size,
        loading: _vm.loading,
      },
      on: { blur: _vm.onBlur, change: _vm.onChange },
      model: {
        value: _vm.id,
        callback: function ($$v) {
          _vm.id = $$v
        },
        expression: "id",
      },
    },
    _vm._l(_vm.options, function (item, index) {
      return _c("el-option", {
        key: index,
        attrs: { label: item["name"], value: String(item["id"]) },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }